module.exports = __webpack_public_path__ + "img/Japanese_population-sp.52c948c3.jpg";